export const MOCK_WAREHOUSES = [
  { id: "wh-cbe-central", name: "Coimbatore Central Warehouse" },
  { id: "wh-peelamedu", name: "Peelamedu Depot" },
  { id: "wh-blr", name: "Warehouse Bangalore" },
  { id: "wh-mys", name: "Warehouse Mysore" },
  { id: "wh-chn", name: "Warehouse Chennai" },
];
